import controller from './four-o-three.controller';
import template from './four-o-three.pug';

const FourOThreeComponent = {
  template,
  controller,
};

export default FourOThreeComponent;



// WEBPACK FOOTER //
// ./client/app/four-o-three/four-o-three.component.js